import React from 'react';
import TypeBadge from './TypeBadge';

const SPRITE_URL = 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/';

function PokemonCard({ pokemon, eliminated, onClick, selectable, selected }) {
  return (
    <div
      className={`pokemon-card${eliminated ? ' eliminated' : ''}${selectable ? ' selectable' : ''}${selected ? ' selected' : ''}`}
      onClick={onClick}
    >
      <img
        src={`${SPRITE_URL}${pokemon.id}.png`}
        alt={pokemon.name}
        className="pokemon-sprite"
        draggable={false}
      />
      <span className="pokemon-name">{pokemon.name}</span>
      {pokemon.type && (
        <div className="pokemon-type-row">
          <TypeBadge type={pokemon.type} />
        </div>
      )}
    </div>
  );
}

export default PokemonCard;
